import { SvgIcon, SvgIconProps } from '@mui/material';
import styles from './ccf-wem-evaluations-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfWemEvaluationsIconProps extends SvgIconProps {}

/**
 * Component used to render WEM Evaluations tab Icon
 * @example
 */
export function CcfWemEvaluationsIcon(props: CcfWemEvaluationsIconProps) {
  return (
    <SvgIcon {...props} width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M15 1H12V0H5V1H2C0.9 1 0 1.9 0 3V16C0 17.1 0.9 18 2 18H10V16H2V3H5V4H12V3H15V8H17V3C17 1.9 16.1 1 15 1Z"
        fill="#7D3CC8"
      />
      <path d="M4 9H10V11H4V9Z" fill="#7D3CC8" />
      <path d="M4 6H10V8H4V6Z" fill="#7D3CC8" />
      <path d="M4 12H10V14H4V12Z" fill="#7D3CC8" />
      <path
        d="M19 17.7C18.5 17.1 17.9 16.7 17.1 16.3L16 15.9L16.9 15.1C17.2 14.9 17.4 14.6 17.6 14.3C17.9 13.8 18.1 13.1 18.1 12.5C18.1 11.7 17.8 10.8 17.2 10.2C17 10 16.9 9.9 16.6 9.7C15.4 8.9 13.7 9.1 12.8 10.2C12.2 10.9 11.9 11.7 11.9 12.5C11.9 13.1 12.1 13.7 12.4 14.3C12.6 14.6 12.8 14.9 13.1 15.1L14 15.8L13 16.3C12.3 16.6 11.6 17.1 11.2 17.7C10.6 18.5 10.2 20 10.2 20H20C20 20 19.6 18.5 19 17.7Z"
        fill="#7D3CC8"
      />
    </SvgIcon>
  );
}

export default CcfWemEvaluationsIcon;
